module.exports = __webpack_public_path__ + "static/customize2-64d7889ac22d7083da2259ebeeafe5d7.png";